// extracted by mini-css-extract-plugin
export default {"box":"More_box__SBBTZ","data":"More_data__hyv0f","heading":"More_heading__9LwFT","subHeading":"More_subHeading__qF63H","cardGroup":"More_cardGroup__VWjt4"};